import { Entity, Field } from "typegraph";
class ProductTyped {
	@Field()
	public shippable: boolean;
}

@Entity({ one: "product", many: "products" })
export class Product {
	@Field({ entity: ProductTyped })
	public type: ProductTyped;
}



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/entities/ProductType.ts